<template>
  <v-sheet
    v-if="editedIndex != -1"
    class="mx-auto"
    elevation="8"
    max-width="1200"
  >
    <v-slide-group
      v-model="modelhojas"
      class="pa-4"
      selected-class="bg-success"
      show-arrows
    >
      <v-slide-group-item
        v-for="n in sheet"
        :key="n"
        v-slot="{ toggle, selectedClass }"
      >
        <v-card
          color="blue-lighten-4"
          :class="['ma-4', selectedClass]"
          height="70"
          width="140"
          @click="
            toggle();
            editItem(n);
          "
        >
          <v-card-item>
            <div>
              <div align="center" class="text-caption">
                <v-icon> {{ n.icono }} </v-icon>
              </div>
              <div align="center" class="text-caption">
                {{ n.descripcion }}
              </div>
            </div>
          </v-card-item>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-expansion-panels v-model="panel" multiple>
      <!--////////////////////////////////////////////// Datos Personales ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-account </v-icon>
            Datos Personales
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!-- Clase de Persona -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoPersona"
                :items="ArrayTipoPersona"
                :item-title="
                  (ArrayTipoPersona) =>
                    ArrayTipoPersona.Valor + '-' + ArrayTipoPersona.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Clase de persona:"
                dense
                clearable
                :update:modelValue="ChangeTypePersona()"
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!-- Régimen -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.Regimen"
                :items="ArrayRegimen"
                :item-title="
                  (ArrayRegimen) =>
                    ArrayRegimen.Valor + '-' + ArrayRegimen.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Régimen:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!-- Nombre 1 -->
            <v-col
              cols="12"
              :sm="editedItem.TipoPersona == '1' ? '3' : '12'"
              :md="editedItem.TipoPersona == '1' ? '3' : '12'"
            >
              <v-text-field
                v-model="editedItem.Nombre"
                label="Nombre:"
                clearable
                maxlength="200"
                counter="200"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
              ></v-text-field>
            </v-col>
            <!-- Nombre 2 -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="3" md="3">
              <v-text-field
                v-model="editedItem.Nombre2"
                label="Segundo Nombre:"
                clearable
                dense
                maxlength="50"
                counter="50"
              ></v-text-field>
            </v-col>
            <!-- Apellido 1 -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="3" md="3">
              <v-text-field
                v-model="editedItem.Apellido1"
                label="Primer Apellido:"
                clearable
                dense
                maxlength="50"
                counter="50"
              ></v-text-field>
            </v-col>
            <!-- Apellido 2 -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="3" md="3">
              <v-text-field
                v-model="editedItem.Apellido2"
                label="Segundo Apellido:"
                clearable
                dense
                maxlength="50"
                counter="50"
              ></v-text-field>
            </v-col>
            <!--Tipo de documento-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TypeDocumentID"
                :items="ArrayTypeDocument_ID"
                :item-title="
                  (ArrayTypeDocument_ID) =>
                    ArrayTypeDocument_ID.Valor +
                    '-' +
                    ArrayTypeDocument_ID.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de documento:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :clearable="clearcampos.TypeDocumentID"
                :readonly="readcampos.TypeDocumentID"
              >
              </v-autocomplete>
            </v-col>
            <!--Documento-->
            <v-col cols="12" sm="4" md="5">
              <v-text-field
                v-model="editedItem.DocumentID"
                label="Documento:"
                hint="Digite Información"
                dense
                :update:modelValue="ChangeDocumento_ID()"
                @change="CalcularDigito()"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :clearable="clearcampos.DocumentID"
                :readonly="readcampos.DocumentID"
              >
              </v-text-field>
            </v-col>
            <!-- Digito de verificación -->
            <v-col v-if="editedItem.TipoPersona == '2'" cols="12" sm="1" md="1">
              <span>Digito: {{ editedItem.DigitoVerificacion }}</span>
            </v-col>
            <!--Departamento expedición-->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.DocDepartamentoID"
                :items="ArrayDpto_IDDoc"
                :item-title="
                  (ArrayDpto_IDDoc) =>
                    ArrayDpto_IDDoc.DepartamentoId +
                    '-' +
                    ArrayDpto_IDDoc.Nombre
                "
                item-value="DepartamentoId"
                color="primary"
                label="Departamento expedición:"
                :update:modelValue="ChangeDepto_IDExpedicion()"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Ciudad expedición-->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.DocCiudadID"
                :items="ArrayCiudad_IDDoc"
                :item-title="
                  (ArrayCiudad_IDDoc) =>
                    ArrayCiudad_IDDoc.CiudadId + '-' + ArrayCiudad_IDDoc.Nombre
                "
                item-value="CiudadId"
                color="primary"
                label="Ciudad de expedición:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha Expedición-->
            <v-col
              v-if="editedItem.TipoPersona == '1'"
              cols="12"
              sm="12"
              md="4"
            >
              <v-text-field
                v-if="editedItem.TipoPersona == '1'"
                v-model="editedItem.FechaExpedicionDocumento"
                label="Fecha Expedición:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!-- País Nacimiento -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="editedItem.PaisID"
                :items="ArrayPais_ID"
                :item-title="
                  (ArrayPais_ID) => ArrayPais_ID.Id + '-' + ArrayPais_ID.Nombre
                "
                item-value="Id"
                color="primary"
                label="País nacimiento:"
                :update:modelValue="ChangePais_IDNacimiento()"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Departamento de Nacimiento-->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="editedItem.DepartamentoID"
                :items="ArrayDpto_ID"
                :item-title="
                  (ArrayDpto_ID) =>
                    ArrayDpto_ID.DepartamentoId + '-' + ArrayDpto_ID.Nombre
                "
                item-value="DepartamentoId"
                color="primary"
                label="Departamento nacimiento:"
                dense
                :update:modelValue="ChangeDepto_IDNacimiento()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Ciudad de Nacimiento-->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="editedItem.CiudadID"
                :items="ArrayCiudad_ID"
                :item-title="
                  (ArrayCiudad_ID) =>
                    ArrayCiudad_ID.CiudadId + '-' + ArrayCiudad_ID.Nombre
                "
                item-value="CiudadId"
                color="primary"
                label="Ciudad nacimiento:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha de nacimiento-->
            <v-col
              v-if="editedItem.TipoPersona == '1'"
              cols="12"
              sm="12"
              md="3"
            >
              <v-text-field
                v-if="editedItem.TipoPersona == '1'"
                v-model="editedItem.FechaNacimiento"
                label="Fecha de nacimiento:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!-- Sexo -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.Sex"
                :items="ArraySexo"
                :item-title="
                  (ArraySexo) => ArraySexo.Valor + '-' + ArraySexo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Sexo:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- RH -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.RH"
                :items="ArrayRH"
                item-title="Descripcion"
                item-value="Valor"
                color="primary"
                label="RH:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Estado Civil -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.EstadoCivil"
                :items="
                  ArrayEstadoCivil.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayEstadoCivil) =>
                    ArrayEstadoCivil.Valor + '-' + ArrayEstadoCivil.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Estado Civil:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Nivel académico -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.NivelAcademico"
                :items="
                  ArrayNivelAcademico.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayNivelAcademico) =>
                    ArrayNivelAcademico.Valor +
                    '-' +
                    ArrayNivelAcademico.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Nivel académico:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Profesional u Ocupación -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.Ocupacion"
                :items="
                  ArrayProfesion.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayProfesion) =>
                    ArrayProfesion.Valor + '-' + ArrayProfesion.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Profesional u Ocupación:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Actividad económica Empresarial y Particular -->
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.ActividadEconomica"
                :items="
                  ArrayActividadEconomica.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayActividadEconomica) =>
                    ArrayActividadEconomica.Valor +
                    '-' +
                    ArrayActividadEconomica.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Actividad económica:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Entidades Pensionales-->
            <v-col
              v-if="
                editedItem.TipoPersona == '1' &&
                editedItem.ActividadEconomica == '3'
              "
              cols="12"
              sm="6"
              md="4"
            >
              <v-autocomplete
                v-model="editedItem.DocumentIDPensional"
                :items="ArrayEntidadPensionada"
                :item-title="
                  (ArrayEntidadPensionada) =>
                    ArrayEntidadPensionada.TypeDocumentID +
                    '-' +
                    ArrayEntidadPensionada.DocumentID +
                    '-' +
                    ArrayEntidadPensionada.Nombre
                "
                :item-value="
                  (ArrayEntidadPensionada) =>
                    ArrayEntidadPensionada.TypeDocumentID +
                    '&' +
                    ArrayEntidadPensionada.DocumentID
                "
                color="primary"
                label="Entidad Pensional:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- EPS -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.DocumentIDEPS"
                :items="ArrayEPS"
                :item-title="
                  (ArrayEPS) =>
                    ArrayEPS.TypeDocumentID +
                    '-' +
                    ArrayEPS.DocumentID +
                    '-' +
                    ArrayEPS.Nombre
                "
                :item-value="
                  (ArrayEPS) =>
                    ArrayEPS.TypeDocumentID + '&' + ArrayEPS.DocumentID
                "
                color="primary"
                label="EPS:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- ARL -->
            <v-col v-if="editedItem.TipoPersona == '1'" cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.DocumentIDARL"
                :items="ArrayARL"
                :item-title="
                  (ArrayARL) =>
                    ArrayARL.TypeDocumentID +
                    '-' +
                    ArrayARL.DocumentID +
                    '-' +
                    ArrayARL.Nombre
                "
                :item-value="
                  (ArrayARL) =>
                    ArrayARL.TypeDocumentID + '&' + ArrayARL.DocumentID
                "
                color="primary"
                label="ARL:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Datos de Acceso ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-information </v-icon>
            Accesos
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!-- Acceso al Sistema -->
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.AccesoSistema"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Acceso al Sistema:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Estado de la Persona -->
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.EstadoPersona"
                :items="ArrayEstadoPerson"
                :item-title="
                  (ArrayEstadoPerson) =>
                    ArrayEstadoPerson.Valor +
                    '-' +
                    ArrayEstadoPerson.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Estado de la persona:"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Grupo de documentos -->
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                v-model="editedItem.GrpDocumentos"
                :items="ArrayGrupoDoc"
                :item-title="
                  (ArrayGrupoDoc) =>
                    ArrayGrupoDoc.GrpDocumentoID +
                    '-' +
                    ArrayGrupoDoc.Descripcion
                "
                item-value="GrpDocumentoID"
                color="primary"
                label="Grupo Documentos:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- ID Calendario Atención: -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.CalendarioAtencion"
                :items="ArrayCalendar"
                :item-title="
                  (ArrayCalendar) =>
                    ArrayCalendar.CalendarioId + '-' + ArrayCalendar.Descripcion
                "
                item-value="CalendarioId"
                color="primary"
                label="ID Calendario Atención:"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- ID Calendario Trabajo: -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.CalendarioTrabajo"
                :items="ArrayCalendar"
                :item-title="
                  (ArrayCalendar) =>
                    ArrayCalendar.CalendarioId + '-' + ArrayCalendar.Descripcion
                "
                item-value="CalendarioId"
                color="primary"
                label="ID Calendario Trabajo:"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Tipo de vinculo -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoVinculo"
                :items="ArrayTipoVinculoPerson"
                :item-title="
                  (ArrayTipoVinculoPerson) => ArrayTipoVinculoPerson.Descripcion
                "
                item-value="Valor"
                outlined
                dense
                chips
                small-chips
                :update:modelValue="ChangeTipoVinculo()"
                label="Tipo de vinculo:"
                :rules="[(v) => (v && v.length > 0) || 'Campo obligatorio']"
                multiple
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!-- Autorización de comunicación -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoComunicacion"
                :items="ArrayAutorizacionCominicate"
                :item-title="
                  (ArrayAutorizacionCominicate) =>
                    ArrayAutorizacionCominicate.Descripcion
                "
                item-value="Valor"
                outlined
                dense
                chips
                small-chips
                label="Autorización de comunicaciones:"
                :rules="[(v) => (v && v.length > 0) || 'Campo obligatorio']"
                multiple
                clearable
              ></v-autocomplete>
            </v-col>
            <!--Código de Banco -->
            <v-col v-if="ocultcampos.Cod_Bank" cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Cod_Bank"
                label="Código Banco:"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!-- Porcentaje de Participación -->
            <v-col v-if="ocultcampos.Por_Participacion" cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Por_Participacion"
                label="Porcentaje de Participación:"
                clearable
                dense
                maxlength="3"
                counter="3"
                type="tel"
                v-on:keypress="isNumber()"
              >
              </v-text-field>
            </v-col>
            <!--Gerente Comercial-->
            <v-col
              v-if="ocultcampos.Document_IDComercial"
              cols="12"
              sm="6"
              md="6"
            >
              <v-autocomplete
                v-model="editedItem.Document_IDComercial"
                :items="ArrayGerenteComercial"
                :item-title="
                  (ArrayGerenteComercial) =>
                    ArrayGerenteComercial.TypeDocumentID +
                    '-' +
                    ArrayGerenteComercial.DocumentID +
                    '-' +
                    ArrayGerenteComercial.Nombre
                "
                :item-value="
                  (ArrayGerenteComercial) =>
                    ArrayGerenteComercial.TypeDocumentID +
                    '&' +
                    ArrayGerenteComercial.DocumentID
                "
                color="primary"
                label="Gerentes Comerciales:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Capacidad de transportadora -->
            <v-col v-if="ocultcampos.ETP" cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.CapacityTransport"
                label="Capacidad de transportadora:"
                dense
                maxlength="3"
                counter="3"
                type="tel"
                v-on:keypress="isNumber()"
                clearable
              >
              </v-text-field>
            </v-col>
            <!---	Autoridad de transporte competente  -->
            <v-col v-if="ocultcampos.ATC" cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.Document_IDATC"
                :items="ArrayATC"
                :item-title="
                  (ArrayATC) =>
                    ArrayATC.TypeDocumentID +
                    '-' +
                    ArrayATC.DocumentID +
                    '-' +
                    ArrayATC.Nombre
                "
                :item-value="
                  (ArrayATC) =>
                    ArrayATC.TypeDocumentID + '&' + ArrayATC.DocumentID
                "
                color="primary"
                label="Autoridad de transporte competente:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!---	ETP  -->
            <v-col v-if="ocultcampos.ETP" cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.Document_IDETP"
                :items="ArrayETP"
                :item-title="
                  (ArrayETP) =>
                    ArrayETP.TypeDocumentID +
                    '-' +
                    ArrayETP.DocumentID +
                    '-' +
                    ArrayETP.Nombre
                "
                :item-value="
                  (ArrayETP) =>
                    ArrayETP.TypeDocumentID + '&' + ArrayETP.DocumentID
                "
                color="primary"
                label="ETP:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "clientes_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: "",
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: "",
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      panel: [0, 1, 2, 3, 4, 5],
      progreso: false,
      componenteview: 0,
      modelhojas: null,
      sheet: [
        {
          icono: "mdi-map-marker-plus",
          descripcion: "Direcciones",
          iconoelegido: 1,
        },
        {
          icono: "mdi-account-multiple-plus",
          descripcion: "Nuevo Contacto",
          iconoelegido: 2,
        },
        {
          icono: "mdi-lock-alert",
          descripcion: "Riesgos",
          iconoelegido: 3,
        },
        {
          icono: "mdi-note",
          descripcion: "Contrato",
          iconoelegido: 4,
        },
        {
          icono: "mdi-home-group",
          descripcion: "Activos",
          iconoelegido: 5,
        },
        {
          icono: "mdi-account-lock",
          descripcion: "Seguros",
          iconoelegido: 6,
        },
        {
          icono: "mdi-folder-open",
          descripcion: "Anexar Documento",
          iconoelegido: 7,
        },
        {
          icono: "mdi-file-search",
          descripcion: "Consulta documentos",
          iconoelegido: 8,
        },
      ],
      buttonSave: false,
      editedItem: {
        TypeDocumentID: null,
        DocumentID: null,
        DigitoVerificacion: null,
        NitID: null,
        PaisID: null,
        DepartamentoID: null,
        CiudadID: null,
        FechaExpedicionDocumento: null,
        DocDepartamentoID: null,
        DocCiudadID: null,
        Nombre: null,
        Nombre2: null,
        Apellido1: null,
        Apellido2: null,
        RH: null,
        CapacityTransport: null,
        CalendarioAtencion: null,
        CalendarioTrabajo: null,
        EstadoPersona: "1",
        CodBank: null,
        TipoPersona: null,
        Regimen: null,
        AccesoSistema: "S",
        AreaID: "0",
        CargoID: "0",
        PoliticaID: "0",
        GrpDocumentos: null,
        NConsecutivo: "0",
        Sex: null,
        FechaNacimiento: null,
        OPCliente: null,
        OPAvaluador: null,
        OPTransito: null,
        OPHacienda: null,
        OPEmpresa: null,
        OPEmpleado: null,
        OPAsesor: null,
        Other1: null,
        Other2: null,
        Other3: null,
        Other4: null,
        Other5: null,
        Other6: null,
        Other7: null,
        OPVisitante: null,
        OPRepresentante: null,
        OPSocio: null,
        OPEPS: null,
        OPARL: null,
        OPETP: null,
        OPConductor: null,
        OPServicios: null,
        OPEntidadPension: null,
        OPGerenteComercial: null,
        PorParticipacion: "0",
        AutoEmail: null,
        AutoSMS: null,
        AutoPhone: null,
        AutoRedSocial: null,
        AutoWP: null,
        BloqRiesgo: null,
        NivelAcademico: null,
        Ocupacion: null,
        ActividadEconomica: null,
        EstadoCivil: null,
        TypeDocumentComercial: null,
        DocumentIDComercial: null,
        TypeDocumentCobranza: null,
        DocumentIDCobranza: null,
        TypeDocumentPension: null,
        DocumentIDPensional: null,
        TypeDocumentEPS: null,
        DocumentIDEPS: null,
        TypeDocumentETP: null,
        DocumentIDETP: null,
        TypeDocumentARL: null,
        DocumentIDARL: null,
        TypeDocumentATC: null,
        DocumentIDATC: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        TipoComunicacion: [],
        TipoVinculo: [],
      },
      defaultItem: {
        TypeDocumentID: null,
        DocumentID: null,
        DigitoVerificacion: null,
        NitID: null,
        PaisID: null,
        DepartamentoID: null,
        CiudadID: null,
        FechaExpedicionDocumento: null,
        DocDepartamentoID: null,
        DocCiudadID: null,
        Nombre: null,
        Nombre2: null,
        Apellido1: null,
        Apellido2: null,
        RH: null,
        CapacityTransport: null,
        CalendarioAtencion: null,
        CalendarioTrabajo: null,
        EstadoPersona: "1",
        CodBank: null,
        TipoPersona: null,
        Regimen: null,
        AccesoSistema: "S",
        AreaID: "0",
        CargoID: "0",
        PoliticaID: "0",
        GrpDocumentos: null,
        NConsecutivo: "0",
        Sex: null,
        FechaNacimiento: null,
        OPCliente: null,
        OPAvaluador: null,
        OPTransito: null,
        OPHacienda: null,
        OPEmpresa: null,
        OPEmpleado: null,
        OPAsesor: null,
        Other1: null,
        Other2: null,
        Other3: null,
        Other4: null,
        Other5: null,
        Other6: null,
        Other7: null,
        OPVisitante: null,
        OPRepresentante: null,
        OPSocio: null,
        OPEPS: null,
        OPARL: null,
        OPETP: null,
        OPConductor: null,
        OPServicios: null,
        OPEntidadPension: null,
        OPGerenteComercial: null,
        PorParticipacion: "0",
        AutoEmail: null,
        AutoSMS: null,
        AutoPhone: null,
        AutoRedSocial: null,
        AutoWP: null,
        BloqRiesgo: null,
        NivelAcademico: null,
        Ocupacion: null,
        ActividadEconomica: null,
        EstadoCivil: null,
        TypeDocumentComercial: null,
        DocumentIDComercial: null,
        TypeDocumentCobranza: null,
        DocumentIDCobranza: null,
        TypeDocumentPension: null,
        DocumentIDPensional: null,
        TypeDocumentEPS: null,
        DocumentIDEPS: null,
        TypeDocumentETP: null,
        DocumentIDETP: null,
        TypeDocumentARL: null,
        DocumentIDARL: null,
        TypeDocumentATC: null,
        DocumentIDATC: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        TipoComunicacion: [],
        TipoVinculo: [],
      },
      clearcampos: {
        DocumentID: true,
        TypeDocumentID: true,
      },
      readcampos: {
        DocumentID: false,
        TypeDocumentID: false,
      },
      ocultcampos: {
        Cod_Bank: false,
        Por_Participacion: false,
        Document_IDComercial: false,
        buttomsconsult: false,
        buttomsarchive: false,
        ETP: false,
        ATC: false,
      },
      ArrayTypeDocument_ID: [],
      ArrayTipoPersona: [],
      ArrayRegimen: [],
      ArrayDpto_IDDoc: [],
      ArrayCiudad_IDDoc: [],
      ArrayPais_ID: [],
      ArrayDpto_ID: [],
      ArrayCiudad_ID: [],
      ArraySexo: [],
      ArrayRH: [],
      ArrayNivelAcademico: [],
      ArrayEstadoCivil: [],
      ArrayProfesion: [],
      ArrayActividadEconomica: [],
      ArrayEntidadPensionada: [],
      ArrayEPS: [],
      ArrayARL: [],
      ArraySiNo: [],
      ArrayEstadoPerson: [],
      ArrayCalendar: [],
      ArrayGrupoDoc: [],
      ArrayTipoVinculoPerson: [],
      ArrayAutorizacionCominicate: [],
      ArrayGerenteComercial: [],
      ArrayATC: [],
      ArrayETP: [],
      CantidadViculo: 0,
      wtipopersona: null,
    };
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Item editar
    editItem(item) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.TypeDocumentID == null ||
        this.editedItem.TypeDocumentID == "" ||
        this.editedItem.DocumentID == "" ||
        this.editedItem.DocumentID == null ||
        this.editedItem.Nombre == "" ||
        this.editedItem.Nombre == null ||
        this.editedItem.TipoVinculo == "" ||
        this.editedItem.TipoVinculo == null ||
        this.editedItem.TipoComunicacion == "" ||
        this.editedItem.TipoComunicacion == null ||
        this.editedItem.TipoPersona == "" ||
        this.editedItem.TipoPersona == null ||
        this.editedItem.Regimen == "" ||
        this.editedItem.Regimen == null ||
        this.editedItem.CalendarioAtencion == "" ||
        this.editedItem.CalendarioAtencion == null ||
        this.editedItem.CalendarioTrabajo == "" ||
        this.editedItem.CalendarioTrabajo == null ||
        this.editedItem.EstadoPersona == "" ||
        this.editedItem.EstadoPersona == null ||
        this.editedItem.AccesoSistema == "" ||
        this.editedItem.AccesoSistema == null
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        await this.RegistrosCombinados();
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
        this.$refs.form.validate();
      }
    },
    // Envio Final de Registros Combinados
    async RegistrosCombinados() {
      var NTR = [];
      // Empresa de Pensión
      if (
        this.editedItem.DocumentIDPensional != "" &&
        this.editedItem.DocumentIDPensional != undefined
      ) {
        NTR = this.editedItem.DocumentIDPensional.split("&");
        this.editedItem.TypeDocumentPension = NTR[0];
        this.editedItem.DocumentIDPensional = NTR[1];
      }
      // Gerente Comercial
      if (
        this.editedItem.Document_IDComercial != "" &&
        this.editedItem.Document_IDComercial != undefined
      ) {
        NTR = this.editedItem.Document_IDComercial.split("&");
        this.editedItem.TypeDocumentComercial = NTR[0];
        this.editedItem.Document_IDComercial = NTR[1];
      }
      // Empresa de EPS
      if (
        this.editedItem.DocumentIDEPS != "" &&
        this.editedItem.DocumentIDEPS != undefined
      ) {
        NTR = this.editedItem.DocumentIDEPS.split("&");
        this.editedItem.TypeDocumentEPS = NTR[0];
        this.editedItem.DocumentIDEPS = NTR[1];
      }
      // Empresa de ETP
      if (
        this.editedItem.Document_IDETP != "" &&
        this.editedItem.Document_IDETP != undefined
      ) {
        NTR = this.editedItem.Document_IDETP.split("&");
        this.editedItem.TypeDocumentETP = NTR[0];
        this.editedItem.Document_IDETP = NTR[1];
      }
      // Empresa de ARL
      if (
        this.editedItem.DocumentIDARL != "" &&
        this.editedItem.DocumentIDARL != undefined
      ) {
        NTR = this.editedItem.DocumentIDARL.split("&");
        this.editedItem.TypeDocumentARL = NTR[0];
        this.editedItem.DocumentIDARL = NTR[1];
      }
      // Empresa de ATC
      if (
        this.editedItem.Document_IDATC != "" &&
        this.editedItem.Document_IDATC != undefined
      ) {
        NTR = this.editedItem.Document_IDATC.split("&");
        this.editedItem.TypeDocumentATC = NTR[0];
        this.editedItem.Document_IDATC = NTR[1];
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/Personas/Cliente/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/Personas/Cliente/UP0", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Consulta EPS
    async getEPS() {
      this.ArrayEPS = [];
      this.axios
        .get("/Personas/Cliente/CD3/3/")
        .then((response) => {
          this.ArrayEPS = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta ETP
    async getETP() {
      this.ArrayETP = [];
      this.axios
        .get("/Personas/Cliente/CD3/4/")
        .then((response) => {
          this.ArrayETP = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta ARL
    async getARL() {
      this.ArrayARL = [];
      this.axios
        .get("/Personas/Cliente/CD3/5/")
        .then((response) => {
          this.ArrayARL = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Entidad Pensión
    async getEntidadPension() {
      this.ArrayEntidadPensionada = [];
      this.axios
        .get("/Personas/Cliente/CD3/6/")
        .then((response) => {
          this.ArrayEntidadPensionada = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Gerente Comercial
    async getGerenteComercial() {
      this.ArrayGerenteComercial = [];
      this.axios
        .get("/Personas/Cliente/CD3/7/")
        .then((response) => {
          this.ArrayGerenteComercial = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta ATC
    async getATC() {
      this.ArrayATC = [];
      this.axios
        .get("/Personas/Cliente/CD3/8/")
        .then((response) => {
          this.ArrayATC = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Calcular Digito de verificación
    async CalcularDigito() {
      console.log("Calcular Digito");
      console.log(this.editedItem.TipoPersona);
      console.log(this.editedItem.DocumentID);
      if (
        this.editedItem.TipoPersona == "2" &&
        this.editedItem.DocumentID != null &&
        this.editedItem.DocumentID != ""
      ) {
        console.log("Entro a calcular");
        this.editedItem.DigitoVerificacion = null;
        this.axios
          .get("/Personas/Cliente/CDDigito/" + this.editedItem.DocumentID)
          .then((response) => {
            this.editedItem.DigitoVerificacion = response.data;
          })
          .catch((e) =>
            this.$swal({
              icon: "error",
              title: "Error al consultar datos",
              html:
                "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
                e.toString() +
                "</code></small>",
            })
          );
      }
    },
    /////////////////////////////////////////////// Métodos Changes ///////////////////////////////////////////////
    // Get para obtener array de los departamento existentes
    getDpto_IDExpedicion() {
      this.ArrayDpto_IDDoc = [];
      var ArrayDpto_ID2 = this.$store.getters.MDpto;
      this.ArrayDpto_IDDoc = ArrayDpto_ID2.filter(
        (item) => item.departamentoId != 0
      );
    },
    // Función de gestion cambio
    ChangeDepto_IDExpedicion() {
      if (
        this.editedItem.DocDepartamentoID == "" ||
        this.editedItem.DocDepartamentoID == null
      ) {
        this.ArrayCiudad_IDDoc = [];
        this.editedItem.CiudadID = null;
      } else {
        this.getCiudad_IDExpedicion();
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudad_IDExpedicion() {
      if (
        this.editedItem.DocDepartamentoID != "" &&
        this.editedItem.DocDepartamentoID != null
      ) {
        this.ArrayCiudad_IDDoc = [];
        var Dpto = this.editedItem.DocDepartamentoID;
        var ArrayCiudadID2 = this.$store.getters.MCity;
        this.ArrayCiudad_IDDoc = ArrayCiudadID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto
        );
      }
    },
    // Función de gestion cambio
    ChangePais_IDNacimiento() {
      if (this.editedItem.PaisID != null && this.editedItem.PaisID != "") {
        this.getDpto_IDNacimiento();
      } else {
        this.ArrayDpto_ID = [];
        this.editedItem.DepartamentoID = null;
      }
    },
    // Get para obtener array de los departamento existentes
    getDpto_IDNacimiento() {
      if (this.editedItem.PaisID == "169") {
        this.ArrayDpto_ID = [];
        var ArrayDpto_ID2 = this.$store.getters.MDpto;
        this.ArrayDpto_ID = ArrayDpto_ID2.filter(
          (item) => item.DepartamentoId != 0
        );
      }
    },
    // Función de gestion cambio
    ChangeDepto_IDNacimiento() {
      if (
        this.editedItem.DepartamentoID == "" ||
        this.editedItem.DepartamentoID == null
      ) {
        this.ArrayCiudad_ID = [];
        this.editedItem.CiudadID = null;
      } else {
        this.getCiudad_IDNacimiento();
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudad_IDNacimiento() {
      if (
        this.editedItem.DepartamentoID != "" &&
        this.editedItem.DepartamentoID != null
      ) {
        this.ArrayCiudad_ID = [];
        var Dpto = this.editedItem.DepartamentoID;
        var ArrayCiudad_ID2 = this.$store.getters.MCity;
        this.ArrayCiudad_ID = ArrayCiudad_ID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto
        );
      }
    },
    // Change Tipo de Vinculo
    ChangeTipoVinculo() {
      if (this.editedItem.TipoVinculo.length > 0) {
        if (this.CantidadViculo != this.editedItem.TipoVinculo.length) {
          this.ocultcampos.Cod_Bank = false;
          this.ocultcampos.Por_Participacion = false;
          this.ocultcampos.Document_IDComercial = false;
          this.ocultcampos.ETP = false;
          this.ocultcampos.ATC = false;
          this.CantidadViculo = this.editedItem.TipoVinculo.length;
          for (var i = 0; i < this.editedItem.TipoVinculo.length; i++) {
            if (this.editedItem.TipoVinculo[i] == 10) {
              this.ocultcampos.Cod_Bank = true;
            }
            if (this.editedItem.TipoVinculo[i] == 14) {
              this.ocultcampos.Por_Participacion = true;
            }
            if (this.editedItem.TipoVinculo[i] == 17) {
              this.ocultcampos.Document_IDComercial = true;
            }
            if (this.editedItem.TipoVinculo[i] == 20) {
              this.ocultcampos.ETP = true;
            }
            if (this.editedItem.TipoVinculo[i] == 21) {
              this.ocultcampos.ATC = true;
            }
          }
        }
      } else {
        this.ocultcampos.Cod_Bank = false;
        this.ocultcampos.Por_Participacion = false;
        this.ocultcampos.Document_IDComercial = false;
        this.ocultcampos.ETP = false;
        this.ocultcampos.ATC = false;
        this.editedItem.Cod_Bank = null;
        this.editedItem.Por_Participacion = null;
        this.editedItem.Document_IDComercial = null;
        this.editedItem.CapacityTransport = null;
        this.editedItem.Document_IDATC = null;
        this.editedItem.Document_IDETP = null;
      }
    },
    // Change Tipo de Persona
    ChangeTypePersona() {
      if (this.wtipopersona != this.editedItem.TipoPersona) {
        this.wtipopersona = this.editedItem.TipoPersona;
        //this.editedItem.ActividadEconomica = null;
        var TablaSelect = this.$store.getters.MTablaSeleccion;
        this.ArrayActividadEconomica =
          this.editedItem.TipoPersona == "1"
            ? TablaSelect.filter(
                (item) => item.Valor != null && item.TablaId == 45
              )
            : TablaSelect.filter(
                (item) => item.Valor != null && item.TablaId == 46
              );
        if (this.editedItem.TipoPersona == "1") {
          this.editedItem.DigitoVerificacion = null;
        } else {
          this.editedItem.Nombre2 = null;
          this.editedItem.Apellido1 = null;
          this.editedItem.Apellido2 = null;
          this.editedItem.DocDepartamentoID = null;
          this.editedItem.DocCiudadID = null;
          this.editedItem.FechaExpedicionDocumento = null;
          this.editedItem.PaisID = 169;
          this.editedItem.DepartamentoID = null;
          this.editedItem.CiudadID = null;
          this.editedItem.FechaNacimiento = null;
          this.editedItem.Sex = null;
          this.editedItem.RH = null;
          this.editedItem.EstadoCivil = null;
          this.editedItem.NivelAcademico = null;
          this.editedItem.Ocupacion = null;
          this.editedItem.DocumentIDPensional = null;
          this.editedItem.DocumentIDEPS = null;
          this.editedItem.DocumentIDARL = null;
        }
      }
      if (
        this.editedItem.TipoPersona == null ||
        this.editedItem.TipoPersona == ""
      ) {
        // General
        this.editedItem.ActividadEconomica = null;
        // Persona Natural
        this.editedItem.Nombre2 = null;
        this.editedItem.Apellido1 = null;
        this.editedItem.Apellido2 = null;
        this.editedItem.DocDepartamentoID = null;
        this.editedItem.DocCiudadID = null;
        this.editedItem.FechaExpedicionDocumento = null;
        this.editedItem.PaisID = 169;
        this.editedItem.DepartamentoID = null;
        this.editedItem.CiudadID = null;
        this.editedItem.FechaNacimiento = null;
        this.editedItem.Sex = null;
        this.editedItem.RH = null;
        this.editedItem.EstadoCivil = null;
        this.editedItem.NivelAcademico = null;
        this.editedItem.Ocupacion = null;
        this.editedItem.DocumentIDPensional = null;
        this.editedItem.DocumentIDEPS = null;
        this.editedItem.DocumentIDARL = null;
        // Persona Jurídica
        this.editedItem.DigitoVerificacion = null;
      }
    },
    // Change Documento
    ChangeDocumento_ID() {
      if (
        this.editedItem.DocumentID == "" ||
        this.editedItem.DocumentID == null
      ) {
        this.editedItem.DigitoVerificacion = null;
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.CantidadViculo = 0;
      this.wtipopersona = null;
    },
    // Cargue Combos
    CargueCombos() {
      var TablaSelect = this.$store.getters.MTablaSeleccion;
      // Array Tipo de Documento
      var TipoDocumento = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 2
      );
      this.ArrayTypeDocument_ID = TipoDocumento;

      var Calendario = this.$store.getters.MCalendario;
      this.ArrayCalendar = Calendario.filter((item) => item.Calendario_ID != 0);
      var Grp_Documento_ID = this.$store.getters.MGrupoDocumentos;
      this.ArrayGrupoDoc = Grp_Documento_ID.filter(
        (item) => item.Grp_Documento_ID != 0
      );

      // Array Si o No
      this.ArraySiNo = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 16
      );

      // Array Tipo Persona
      this.ArrayTipoPersona = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 38
      );

      // Array Regimen
      this.ArrayRegimen = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 39
      );

      // Array Sexo
      this.ArraySexo = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 40
      );

      // Array RH
      this.ArrayRH = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 41
      );

      // Array Estado Civil
      this.ArrayEstadoCivil = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 42
      );

      // Array Nivel Académico
      this.ArrayNivelAcademico = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 43
      );

      // Arra Profesion
      this.ArrayProfesion = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 44
      );

      // Array Estado Persona
      this.ArrayEstadoPerson = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 47
      );

      // Array Tipo Vinculo Persona
      this.ArrayTipoVinculoPerson = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 48
      );

      // Array Autorizacion
      this.ArrayAutorizacionCominicate = TablaSelect.filter(
        (item) => item.Valor != null && item.TablaId == 49
      );
      var ArrayPais = this.$store.getters.MPais;
      this.ArrayPais_ID = ArrayPais.filter((item) => item.Id != 0);
      this.getDpto_IDExpedicion();
      this.getEPS();
      this.getARL();
      this.getETP();
      this.getEntidadPension();
      this.getGerenteComercial();
      this.getATC();
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.TypeDocumentID = false;
        this.readcampos.TypeDocumentID = true;
        this.clearcampos.DocumentID = false;
        this.readcampos.DocumentID = true;
        // Gerente Comercial
        if (
          this.editedItem.TypeDocumentComercial != null &&
          this.editedItem.TypeDocumentComercial != "" &&
          this.editedItem.Document_IDComercial != null &&
          this.editedItem.Document_IDComercial != ""
        ) {
          this.editedItem.Document_IDComercial =
            this.editedItem.TypeDocumentComercial +
            "&" +
            this.editedItem.Document_IDComercial;
        }
        // Pension
        if (
          this.editedItem.TypeDocumentPension != null &&
          this.editedItem.TypeDocumentPension != "" &&
          this.editedItem.DocumentIDPensional != null &&
          this.editedItem.DocumentIDPensional != ""
        ) {
          this.editedItem.DocumentIDPensional =
            this.editedItem.TypeDocumentPension +
            "&" +
            this.editedItem.DocumentIDPensional;
        }
        // EPS
        if (
          this.editedItem.TypeDocumentEPS != null &&
          this.editedItem.TypeDocumentEPS != "" &&
          this.editedItem.DocumentIDEPS != null &&
          this.editedItem.DocumentIDEPS != ""
        ) {
          this.editedItem.DocumentIDEPS =
            this.editedItem.TypeDocumentEPS +
            "&" +
            this.editedItem.DocumentIDEPS;
        }
        // ARL
        if (
          this.editedItem.TypeDocumentARL != null &&
          this.editedItem.TypeDocumentARL != "" &&
          this.editedItem.DocumentIDARL != null &&
          this.editedItem.DocumentIDARL != ""
        ) {
          this.editedItem.DocumentIDARL =
            this.editedItem.TypeDocumentARL +
            "&" +
            this.editedItem.DocumentIDARL;
        }
        // ETP
        if (
          this.editedItem.TypeDocumentETP != null &&
          this.editedItem.TypeDocumentETP != "" &&
          this.editedItem.Document_IDETP != null &&
          this.editedItem.Document_IDETP != ""
        ) {
          this.editedItem.Document_IDETP =
            this.editedItem.TypeDocumentETP +
            "&" +
            this.editedItem.Document_IDETP;
        }
        // ATC
        if (
          this.editedItem.TypeDocumentATC != null &&
          this.editedItem.TypeDocumentATC != "" &&
          this.editedItem.Document_IDATC != null &&
          this.editedItem.Document_IDATC != ""
        ) {
          this.editedItem.Document_IDATC =
            this.editedItem.TypeDocumentATC +
            "&" +
            this.editedItem.Document_IDATC;
        }
        // LLenar matrices de Tipo de vinculo y Persona
        var matrizvinculo = [];
        var matrizcomunicate = [];
        if (this.editedItem.OPCliente == "S") {
          matrizvinculo.push("0");
        }
        if (this.editedItem.OPTransito == "S") {
          matrizvinculo.push("1");
        }
        if (this.editedItem.OPEmpresa == "S") {
          matrizvinculo.push("2");
        }
        if (this.editedItem.OP_Asesor == "S") {
          matrizvinculo.push("3");
        }
        if (this.editedItem.Other2 == "S") {
          matrizvinculo.push("4");
        }
        if (this.editedItem.OPEntidadPension == "S") {
          matrizvinculo.push("5");
        }
        if (this.editedItem.OPRepresentante == "S") {
          matrizvinculo.push("6");
        }
        if (this.editedItem.OPServicios == "S") {
          matrizvinculo.push("7");
        }
        if (this.editedItem.Other7 == "S") {
          matrizvinculo.push("8");
        }
        if (this.editedItem.OPAvaluador == "S") {
          matrizvinculo.push("9");
        }
        if (this.editedItem.OPHacienda == "S") {
          matrizvinculo.push("10");
        }
        if (this.editedItem.OPEmpleado == "S") {
          matrizvinculo.push("11");
        }
        if (this.editedItem.Other1 == "S") {
          matrizvinculo.push("12");
        }
        if (this.editedItem.OPVisitante == "S") {
          matrizvinculo.push("13");
        }
        if (this.editedItem.OPSocio == "S") {
          matrizvinculo.push("14");
        }
        if (this.editedItem.Other3 == "S") {
          matrizvinculo.push("15");
        }
        if (this.editedItem.Other6 == "S") {
          matrizvinculo.push("16");
        }
        if (this.editedItem.OPGerenteComercial == "S") {
          matrizvinculo.push("17");
        }
        if (this.editedItem.OPEPS == "S") {
          matrizvinculo.push("18");
        }
        if (this.editedItem.OPARL == "S") {
          matrizvinculo.push("19");
        }
        if (this.editedItem.OPETP == "S") {
          matrizvinculo.push("20");
        }
        if (this.editedItem.OPConductor == "S") {
          matrizvinculo.push("21");
        }
        if (this.editedItem.Other4 == "S") {
          matrizvinculo.push("22");
        }
        //Comunicaciones personas en matriz
        if (this.editedItem.AutoEmail == "0") {
          matrizcomunicate.push("0");
        }
        if (this.editedItem.AutoSMS == "0") {
          matrizcomunicate.push("1");
        }
        if (this.editedItem.AutoPhone == "0") {
          matrizcomunicate.push("2");
        }
        if (this.editedItem.AutoRedSocial == "0") {
          matrizcomunicate.push("3");
        }
        if (this.editedItem.AutoWP == "0") {
          matrizcomunicate.push("4");
        }
        this.editedItem.TipoVinculo = matrizvinculo;
        this.editedItem.TipoComunicacion = matrizcomunicate;
      } else {
        this.clearcampos.TypeDocumentID = true;
        this.readcampos.TypeDocumentID = false;
        this.clearcampos.DocumentID = true;
        this.readcampos.DocumentID = false;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
    if (this.infollaves != null) {
      this.editedItem.TypeDocumentID =
        this.infollaves.TypeDocument_ID != null
          ? this.infollaves.TypeDocument_ID
          : null;
      this.editedItem.DocumentID =
        this.infollaves.Document_ID != null
          ? this.infollaves.Document_ID
          : null;
    }
  },
};
</script>
